  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import { fetchRedeemProducts } from "../../api/redeem.api";
  import "./Redeempage.css";

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

  const buildImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (/^https?:\/\//i.test(imagePath)) return imagePath;

    const base = API_BASE_URL.endsWith("/")
      ? API_BASE_URL.slice(0, -1)
      : API_BASE_URL;

    if (imagePath.startsWith("/")) {
      return `${base}${imagePath}`;
    }

    return `${base}/${imagePath}`;
  };

  const normalizeProducts = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.results)) return data.results;
    if (Array.isArray(data?.products)) return data.products;
    return [];
  };

  const Redeempage = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
      let mounted = true;

      fetchRedeemProducts()
        .then((data) => {
          if (!mounted) return;

          const list = normalizeProducts(data).filter(
            (item) => item && item.is_active !== false
          );

          setProducts(list);
        })
        .catch(() => {
          if (!mounted) return;
          setError("Unable to load redeem products right now.");
          setProducts([]);
        })
        .finally(() => {
          if (mounted) setLoading(false);
        });

      return () => {
        mounted = false;
      };
    }, []);

    if (loading) {
      return (
        <section className="redeem-page">
          <div className="loading-wrap">
            <div className="loader" />
            <div>Loading redeem products...</div>
          </div>
        </section>
      );
    }

    if (error) {
      return (
        <section className="redeem-page">
          <div className="redeem-box redeem-centered redeem-error">{error}</div>
        </section>
      );
    }

    if (!products.length) {
      return (
        <section className="redeem-page">
          <div className="redeem-box redeem-centered">No redeem products available right now.</div>
        </section>
      );
    }

    return (
      <section className="page">
        <div className="breadcrumb11">
          <div className="page-container">
            <span onClick={() => navigate("/")}>Home</span>
            <span className="highlight"> / </span>
            <span
              className="breadcrumb-link"
            >
            Redeempage
            </span>
            <span className="highlight"> / </span>
            <span>{products.length}</span>
          </div>
      </div>

        <div className="redeem-content redeem-content-full">
          <div className="redeem-notice">
            <p>
              Items on the Redeem page are updated every 60 days. Be sure to unlock and redeem your favorites before they&apos;re gone!
            </p>
            <p>
              <strong>Kindly Note:</strong> Damage/ Lost in Transit is Not covered for the items claimed.
            </p>
          </div>

          <div className="redeem-grid">
	            {products.map((item) => {
	              const points = Number(item.points_required);
	              const showPoints = Number.isFinite(points) && points > 0;

	              return (
                <article
                  key={item.id}
                  className="redeem-card"
                  onClick={() => navigate(`/Redeempage/${item.id}`)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      navigate(`/Redeempage/${item.id}`);
                    }
                  }}
	                >
	                  <div className="redeem-card-image">
	                    {showPoints && (
	                      <div className="redeem-points-badge">₹{points} Rewards</div>
	                    )}
	                    {item.image ? (
	                      <img src={buildImageUrl(item.image)} alt={item.name} />
	                    ) : (
                      <div className="redeem-fallback">No image</div>
                    )}
                  </div>

	                  <div className="redeem-card-content">
	                    <h3>{item.name}</h3>
	                    <div className="redeem-card-label">Redeem NOW for FREE !!</div>

	                    {showPoints && (
	                      <div className="redeem-card-meta">
	                        <span className="redeem-points-text">₹{points} Rewards</span>
	                      </div>
	                    )}

	                    <button
                      type="button"
                      className="redeem-view-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/Redeempage/${item.id}`);
                      }}
                    >
                      View Details
                    </button>
                  </div>
                </article>
              );
            })}
          </div>

          <p className="redeem-count">
            Showing 1 - {products.length} of {products.length} products
          </p>
        </div>
      </section>
    );
  };

  export default Redeempage;
